import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[_c(VCardTitle,[_vm._v(" 图片预览 ")]),_c(VCardText,{staticClass:"d-flex justify-center"},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":"暂无图片"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }